import {getRightPrice, getRightTerm, number_format} from "../helpers";
import {translator} from "../helpers/translator";
import * as $ from "jquery";

export function renderTicketsInfo(WIDGET_DATA) {
    const $orderInfoTicketsWrapper = $('#ticket_system__order_info_tickets_wrapper');
    let result = ``;

    WIDGET_DATA.chosenTickets.forEach(ticket => {
        let ticketName =`${translator('Билет на матч', WIDGET_DATA.lang)} ${WIDGET_DATA?.matchInfo?.teams[0]?.name} - ${WIDGET_DATA?.matchInfo?.teams[1]?.name}`;
        let ticketDate = WIDGET_DATA?.matchInfo?.date;

        if (WIDGET_DATA.isAbonement) {
            ticketName = `${WIDGET_DATA.abonementData.name}`;
            ticketDate = WIDGET_DATA.abonementData.year;
        }

        result += `<div class="ticket-system__order-info-ticket">
                        <div class="ticket-system__order-info-ticket-logos-block">
                            <div class="ticket-system__order-info-ticket-logo" style="background-image:url(${WIDGET_DATA?.matchInfo?.teams[0]?.image})"></div>
                            <div class="ticket-system__order-info-ticket-logos-divider"></div>
                            <div class="ticket-system__order-info-ticket-logo" style="background-image:url(${WIDGET_DATA?.matchInfo?.teams[1]?.image})"></div>
                        </div>
                        <div class="ticket-system__order-info-ticket-main-info" data-ticket-system-order-info-ticket-remove-id="${ticket.id}">
                            <div class="ticket-system__order-info-ticket-about-match">
                                <div class="ticket-system__order-info-ticket-about-match__match-name">${ticketName}</div>
                                <div class="ticket-system__order-info-ticket-about-match__match-date">${ticketDate}</div>
                                <div class="ticket-system__order-info-ticket-about-ticket ticket-system__hide-desktop">
                                <div class="ticket-system__order-info-ticket-about-ticket__col">
                                    <div class="ticket-system__order-info-ticket-about-ticket__name">Сектор</div>
                                    <div class="ticket-system__order-info-ticket-about-ticket__value">${WIDGET_DATA.chosenSector.name}</div>
                                </div>
                                <div class="ticket-system__order-info-ticket-about-ticket__col">
                                    <div class="ticket-system__order-info-ticket-about-ticket__name">Ряд</div>
                                    <div class="ticket-system__order-info-ticket-about-ticket__value">${ticket.rowNumber}</div>
                                </div>
                                <div class="ticket-system__order-info-ticket-about-ticket__col">
                                    <div class="ticket-system__order-info-ticket-about-ticket__name">Место</div>
                                    <div class="ticket-system__order-info-ticket-about-ticket__value">${ticket.placeNumber}</div>
                                </div>
                            </div>
                            </div>
                            <div class="ticket-system__order-info-ticket-about-ticket ticket-system__hide-mobile">
                                <div class="ticket-system__order-info-ticket-about-ticket__col">
                                    <div class="ticket-system__order-info-ticket-about-ticket__name">Сектор</div>
                                    <div class="ticket-system__order-info-ticket-about-ticket__value">${WIDGET_DATA.chosenSector.name}</div>
                                </div>
                                <div class="ticket-system__order-info-ticket-about-ticket__col">
                                    <div class="ticket-system__order-info-ticket-about-ticket__name">Ряд</div>
                                    <div class="ticket-system__order-info-ticket-about-ticket__value">${ticket.rowNumber}</div>
                                </div>
                                <div class="ticket-system__order-info-ticket-about-ticket__col">
                                    <div class="ticket-system__order-info-ticket-about-ticket__name">Место</div>
                                    <div class="ticket-system__order-info-ticket-about-ticket__value">${ticket.placeNumber}</div>
                                </div>
                            </div>
                            <div class="ticket-system__order-info-ticket-price-and-delete">
                                <div class="ticket-system__order-info-ticket-price">${number_format(ticket.price,0, '', ' ')} ₽</div>
                                <div class="ticket-system__order-info-ticket-delete">
                                    <span class="ticket-system__hide-mobile">Удалить</span>
                                    <svg class="ticket-system__hide-desktop" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#989FB1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M15 9L9 15" stroke="#989FB1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M9 9L15 15" stroke="#989FB1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                   </div>`
    });

    if(WIDGET_DATA.chosenTickets.length > 0){
        $('.ticket-system__order-info-block-prices').removeClass('ticket-system__hide');
    }

    //выключаем бонусы (для ререндера и последующего пересчета заказа)
    /*$('.ticket-system__toggle-bonuses').find('.switcher-gray').removeClass('active');*/

    calculateFullPrice(WIDGET_DATA);
    $orderInfoTicketsWrapper.html(result)
}

export function renderParking(WIDGET_DATA) {
    const $orderInfoParkingWrapper = $('#ticket_system__order_parking_wrapper');
    const $parkingModalWrapper = $('[data-ticket_system-modal-parking-wrapper]');

    let parkingResult = ``;
    let chosenParkingResult = ``;
    let parkingMinPrice = 99999;


    WIDGET_DATA.parkingProducts.forEach(parking => {
        if (parking.price < parkingMinPrice) {
            parkingMinPrice = parking.price;
        }

        parkingResult += `
            <div class="ticket-system__order-service-item">
                <div class="ticket-system__order-parking-round" style="background-color:${parking.color};">${parking.parkingSector}</div>
                <div class="ticket-system__order-service-item-text-block">
                    <div class="ticket-system__order-service-item-text">ПАРКИНГ СЕКТОР ${parking.parkingSector}</div>
                    <div class="ticket-system__order-service-item-price">от ${number_format(parking.price, '', '', ' ')} ₽</div>
                </div>
                <div class="ticket-system__order-parking-item-button"
                    data-ticket-service-name="${parking.name}"
                    data-ticket-service-price="${parking.price}"
                    data-ticket-service-id="${parking.id}"></div>
            </div>`;

        //если есть в выбранных паркингах - добавляем в макет
        if(findInChosenParking(parking.id)){
            chosenParkingResult += `
            <div class="ticket-system__order-service-item chosen-parking">
                <div class="ticket-system__order-info-chosen-parking-delete"
                     data-ticket-service-name="${parking.name}"
                     data-ticket-service-price="${parking.price}"
                     data-ticket-service-id="${parking.id}"
                >
                          <div class="ticket-system__icon__close order-info"></div>
                </div>
                <div class="ticket-system__chosen-parking-info">
                    <div class="ticket-system__order-parking-round" style="background-color:${parking.color};">${parking.parkingSector}</div>
                    <div class="ticket-system__order-service-item-text-block">
                        <div class="ticket-system__order-service-item-text">ПАРКИНГ СЕКТОР ${parking.parkingSector}</div>
                    </div>
                </div>
                 <div class="ticket-system__order-info-ticket-price-block">
                        ${getRightPrice(+parking.price)} ₽
                  </div>
            </div>`;
        }

        function findInChosenParking(parkingId){
            let result = false;
            result = WIDGET_DATA.chosenParkings.find(chosenParking => {
                return chosenParking.id === parkingId;
            });

            return result;
        }
    });

    const parkingMainBlockHTML = `
          <div class="ticket-system__order-service-item parking">
                 <img class="ticket-system__order-service-item-image" src="./img/mockup/orderInfo/parking-service.svg" alt=""/>
                <div class="ticket-system__order-service-item-text-block">
                    <div class="ticket-system__order-service-item-text">Платный паркинг у стадиона</div>
                    <div class="ticket-system__order-service-item-price">от ${number_format(parkingMinPrice, '', '', ' ')} ₽</div>
                </div>
                <div class="ticket-system__order-service-item-button parking">Добавить</div>
            </div>`;

    //это в модалку parkingResult
    $parkingModalWrapper.html(parkingResult);
    $orderInfoParkingWrapper.html(chosenParkingResult + parkingMainBlockHTML);

    calculateFullPrice(WIDGET_DATA);
}

export function renderServices(WIDGET_DATA) {
    const $orderInfoServicesWrapper = $('#ticket_system__order_services_wrapper');
    let serviceProductsResult = ``;

    WIDGET_DATA.serviceProducts.forEach(service => {
        serviceProductsResult += `
                <div class="ticket-system__order-service-item" data-service-id="${service.id}">
                    <div class="ticket-system__order-info-service-right">
                          <div class="ticket-system__icon__close order-info"></div>
                    </div>
                    <div class="ticket-system__service-item-left">
                         <img class="ticket-system__order-service-item-image" src="${service.img}" alt=""/>
                    <div class="ticket-system__order-service-item-text-block">
                        <div class="ticket-system__order-service-item-text">${service.name}</div>
                        <div class="ticket-system__order-service-item-price">от ${number_format(service.price, '', '', ' ')} ₽</div>
                    </div>
                    <div class="ticket-system__order-service-item-button" 
                    data-ticket-service-name="${service.name}"
                    data-ticket-service-image="${service.img}"
                    data-ticket-service-price="${service.price}"
                    data-ticket-service-id="${service.id}">Добавить</div> 
                   </div>
                    <div class="ticket-system__order-info-ticket-price-block">
                        ${getRightPrice(+service.price)} ₽
                    </div>
                </div>
            `
    })

    $orderInfoServicesWrapper.html(serviceProductsResult);

    calculateFullPrice(WIDGET_DATA);
}

export function calculateFullPrice(WIDGET_DATA) {
    let fullPrice, priceWithSales;
    let ticketsPrice = 0;
    let parkingPrice = 0;
    let servicePrice = 0;

    const $orderInfoFullPriceBlock = $('.ticket-system__order-full-price');
    const $orderInfoMobRolledPriceBlock = $('[data-ticket_system-order-info-mob-price-value]');
    const $orderInfoTicketsPriceBlock = $('[data-ticket-system__order-info-tickets-price-value]');
    const $orderInfoParkingPriceBlock = $('[data-ticket-system__order-info-parking-price]');
    const $orderInfoServicePriceBlock = $('[data-ticket-system__order-info-additional-price]');
    const $bonusesSwitcher = $('.switcher-gray');
    let ticketsCount = 0;

    WIDGET_DATA.chosenTickets.forEach(ticket => {
        if(ticketsCount < WIDGET_DATA.availableDiscountTickets){
            //если место из reservedSeats и поле discount=true
            if(ticket.discount){
                ticketsPrice += +ticket.price;

            }else{
                ticketsPrice += +ticket.price / 2;
            }

            ticketsCount++;

        }else{
            ticketsPrice += +ticket.price;
        }
    });

    WIDGET_DATA.chosenParkings.forEach(parking => {
        parkingPrice += +parking.price;
    });

    WIDGET_DATA.chosenServices.forEach(service => {
        servicePrice += +service.price;
    });

    $orderInfoTicketsPriceBlock.data('ticket-system__order-info-tickets-price-value', ticketsPrice);
    $orderInfoTicketsPriceBlock.text(`${getRightPrice(ticketsPrice)} ₽`);

    $orderInfoParkingPriceBlock.data('ticket-system__order-info-parking-price', parkingPrice);
    $orderInfoParkingPriceBlock.text(`${getRightPrice(parkingPrice)} ₽`);

    $orderInfoServicePriceBlock.data('ticket-system__order-info-additional-price', servicePrice);
    $orderInfoServicePriceBlock.text(`${getRightPrice(servicePrice)} ₽`);

    fullPrice = ticketsPrice + parkingPrice + servicePrice;

    priceWithSales = fullPrice;

    $orderInfoFullPriceBlock.data('ticket_system-order-info-price-value', fullPrice);

    //если есть промокод
    if(WIDGET_DATA.promocodeData.min_value !== null &&
        WIDGET_DATA.promocodeData.min_value <= fullPrice &&
        WIDGET_DATA.promocodeData.discount_value &&
        WIDGET_DATA.isPromocodesAvailable){

        $('.ticket-system__promocode-activate').addClass('ticket-system__hide');
        $('.ticket-system__promocode-activated-promocode').removeClass('ticket-system__hide');


        if(WIDGET_DATA.promocodeData.discount_type === '%'){
            priceWithSales = priceWithSales - priceWithSales * (WIDGET_DATA.promocodeData.discount_value / 100);

        }else if(WIDGET_DATA.promocodeData.discount_type === '₽'){
            priceWithSales = priceWithSales - WIDGET_DATA.promocodeData.discount_value;
        }

    }else{
        WIDGET_DATA.promocodeData.min_value = null;
        WIDGET_DATA.promocodeData.discount_value = 0;
        WIDGET_DATA.promocodeData.discount_type = '';

        if(WIDGET_DATA.isPromocodesAvailable){
            $('.ticket-system__promocode-activate').removeClass('ticket-system__hide');
        }

        $('[data-promocode-in-price-block]').addClass('ticket-system__hide');
        $('.promocode-success').addClass('ticket-system__hide');
        $('.ticket-system__del-promocode').addClass('ticket-system__hide');
        $('#promocode_input').val('');
        $('#promocode_input').parent().removeClass('success').removeClass('error').addClass('empty');
        $('#promocode_input').attr('disabled', false);
    }

    let priceWithSale = 0;

    if($bonusesSwitcher.hasClass('active')){
        priceWithSale = WIDGET_DATA.priceWriteOff;

        $('[data-bonuses-in-price-block]').removeClass('ticket-system__hide');
        $('[data-bonuses-in-price-block-value]').text(`- ${getRightPrice(WIDGET_DATA.bonusesWriteOff)} ₽`);

    }else{
        priceWithSale = WIDGET_DATA.priceAccrue;
        $('[data-bonuses-in-price-block]').addClass('ticket-system__hide');
        $('[data-bonuses-in-price-block-value]').text('');
    }

    if(WIDGET_DATA.fullPrice !== priceWithSale){
        $orderInfoFullPriceBlock.html(`<span class="ticket-system__old-price">${getRightPrice(WIDGET_DATA.fullPrice)} ₽</span><span>${getRightPrice(priceWithSale)} ₽</span>`);
        $orderInfoMobRolledPriceBlock.html(`<span class="ticket-system__old-price">${getRightPrice(WIDGET_DATA.fullPrice)} ₽</span><span>${getRightPrice(priceWithSale)} ₽</span>`);
        $('[data-ticket-system-submit-order-full-price]').html(`<span class="ticket-system__old-price">${getRightPrice(WIDGET_DATA.fullPrice)} ₽</span><span>${getRightPrice(priceWithSale)} ₽</span>`);

    }else{
        $orderInfoFullPriceBlock.html(`<span>${getRightPrice(WIDGET_DATA.fullPrice)} ₽</span>`);
        $('[data-ticket-system-submit-order-full-price]').html(`<span>${getRightPrice(WIDGET_DATA.fullPrice)} ₽</span>`);
        $orderInfoMobRolledPriceBlock.html(`<span>${getRightPrice(WIDGET_DATA.fullPrice)} ₽</span>`);
    }

    $('[data-full-tickets-price]').text(`${getRightPrice(WIDGET_DATA.fullPrice)} ₽`);
    $('[data-ticket-system-count-order]').text(`${WIDGET_DATA.chosenTickets.length} ${getRightTerm(+WIDGET_DATA.chosenTickets.length, 'товар', 'товара', 'товаров')}`)

    WIDGET_DATA.orderFullPrice = WIDGET_DATA.fullPrice;
    WIDGET_DATA.orderFullPriceWithoutBonuses = WIDGET_DATA.fullPrice;
}